import React from 'react';
import './pages.css';

const Home: React.FC = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Traceability Tool</h1>
      <p className="home-subtitle">by Orobix</p>
      <div className="page-description">
        <p>
          The AV Traceability Tool is a web application for managing, refining, and comparing requirements (URS and Client RF) 
          using advanced LLM-powered pipelines. The tool supports Excel and PDF inputs, provides interactive categorization and 
          refinement, and enables side-by-side comparison of requirement sets.
        </p>
        <h2 className="section-title">Features:</h2>
        <ul>
          <li><strong>Extraction:</strong> Extract requirements from PDF and DOCX files</li>
          <li><strong>Categorization:</strong> Classify requirements into sections and subsections</li>
          <li><strong>Refinement:</strong> Refine requirements using LLMs with context-aware improvements</li>
          <li><strong>Comparison:</strong> Compare different requirement sets side-by-side</li>
        </ul>
      </div>
    </div>
  );
};

export default Home;

